// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1885":"17800e17","3797":"17800e17","7374":"16faff94"}[chunkId] + ".chunk.css";
};